System.register(["./dyn-jsx-runtime.js", "./dyn-index.js", "./dyn-goober.modern.js", "./dyn-index2.js", "./dyn-parallax-banner.js"], function(exports, module) {
  "use strict";
  var jsxRuntimeExports, clsx, reactExports, u, j, h, useMobile, animate;
  return {
    setters: [(module2) => {
      jsxRuntimeExports = module2.j;
      clsx = module2.c;
    }, (module2) => {
      reactExports = module2.r;
    }, (module2) => {
      u = module2.u;
      j = module2.j;
      h = module2.h;
    }, (module2) => {
      useMobile = module2.u;
    }, (module2) => {
      animate = module2.a;
    }],
    execute: function() {
      exports("default", Timeline);
      const classes = {
        item: u`/* item */`,
        active: u`/* active */`,
        disabled: u`/* disabled */`
      };
      const breath = h`
  0% {
    background-size: 100% 100%;
  }
  50% {
    background-size: 300% 100%;
  }
  100% {
    background-size: 100% 100%;
  }
`;
      const MainWrapper = j("div")`
  position: relative;
  padding: 48px 60px;
  margin: 0 auto;
  max-width: 100vw;
  overflow-x: hidden;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
  background: linear-gradient(180deg, #bac7d2 0%, rgba(2, 2, 2, 0) 100%);
  z-index: 1;

  &:before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: 1px;
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
    background: linear-gradient(180deg, #1b1e25 0%, #040404 100%);
    z-index: -1;
  }

  h3 {
    font-size: 60px;
    line-height: 72px;
    font-weight: 600;
    margin-bottom: 16px;
    text-align: center;
    @media screen and (max-width: 767px) {
      font-size: 32px;
      line-height: 1.2;
      white-space: nowrap;
    }
  }

  .section-desc {
    max-width: 980px;
    font-weight: 500;
    font-size: 24px;
    line-height: 32px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    @media screen and (max-width: 767px) {
      font-size: 14px;
      line-height: 1.35;
    }
  }

  .timeline-content {
    display: flex;
    flex-direction: column;
    @media screen and (max-width: 767px) {
      position: relative;
      flex-direction: row;
    }
  }

  .progress {
    position: relative;
    padding: 40px 0;

    &:before,
    &:after {
      position: absolute;
      content: '';
      top: 50%;
      z-index: 2;
    }
    &:before {
      left: 0;
      width: var(--progress, 0px);
      height: 8px;
      transform: translateY(-50%);
      background: linear-gradient(90deg, rgba(57, 39, 255, 0) 18.97%, rgba(38, 244, 255, 0.7) 71.42%, rgba(255, 255, 255, 0.7) 98.96%);
      backdrop-filter: blur(13.5px);
      mix-blend-mode: plus-lighter;
      border-radius: 20px;
      box-shadow: 0 0 10px 2px #3927FFAA, 0 0 17px 0 #26F4FF;
    }
    &:after {
      width: 127px;
      left: var(--progress, 0px);
      height: 80px;
      transform: translateX(-50%) translateY(-50%);
      background-image: ${(props) => `url(${props.image})`};
      background-size: cover;
    }

    @media screen and (max-width: 767px) {
      width: 8px;
      padding: 0 20px;
      left: 0;
      transform: translateX(-50%);
      top: 0;
      &:before,
      &:after {
        display: none;
      }
      .timeline-bar {
        height: 100%;
        width: 8px;
        border-radius: 20px;
        background: linear-gradient(90deg, #1B1E25 0%, #1B1E25 100%);
        overflow: hidden;
        &:before {
          position: absolute;
          content: '';
          width: 8px;
          border-radius: 999px;
          height: var(--progress, 0px);
          background: none;
          mix-blend-mode: plus-lighter;
        }
        &:after {
          content: '';
          display: block;
          width: 8px;
          border-radius: 999px;
          height: var(--progress, 0px);
          background: linear-gradient(180deg, #3927FF 0%, #26F4FF 97.98%);

        }
      }
    }
  }

  .timeline-bar {
    height: 8px;
    border-radius: 20px;
    width: 100%;
    background: #0b0b0b;
    overflow: hidden;

    &:before {
      position: absolute;
      content: '';
      width: var(--progress, 0px);
      height: 8px;
      background: linear-gradient(
        90deg,
        rgba(0, 0, 0, 0) 46.47%,
        #00f2ff 97.28%
      );
      mix-blend-mode: plus-lighter;
    }

    &:after {
      content: '';
      display: block;
      width: var(--progress, 0px);
      height: 8px;
      background: linear-gradient(90deg, #3927ff 0%, #26f4ff 97.98%);
      animation: ${breath} 1.5s ease-in-out;
    }
  }

  @media screen and (max-width: 767px) {
    border-radius: 0;
    background: none;
    padding: 0;
    overflow: visible;
    &:before {
      display: none;
    }
  }
`;
      const Container = j("div", reactExports.forwardRef)`
  display: flex;
  width: 100%;
  justify-content: space-around;
  @media screen and (max-width: 767px) {
    flex-direction: column;
    position: relative;
    z-index: 1;
  }
`;
      const Item = j("div")`
  position: relative;
  display: inline-block;
  text-align: center;
  min-width: 168px;
  padding-top: 20px;

  h5,
  p {
    font-size: 18px;
    line-height: 1.5;
    margin: 0;
  }

  i {
    position: absolute;
    display: block;
    width: 20px;
    height: 20px;
    top: 0;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
  }

  a {
    display: inline-block;
    text-decoration: none;
    padding: 6px 24px;
    background-color: #202224;
    border-radius: 999px;
    font-weight: 600;
    color: #fff;
    margin-top: 12px;
    pointer-events: none;
    cursor: not-allowed;
    user-select: none;
  }

  &.${classes.active} a {
    background: linear-gradient(90deg, #35ebff 0%, #025bff 100%);
    pointer-events: auto;
    cursor: pointer;
  }
  &.${classes.disabled} a {
    background: #202224;
  }

  @media screen and (max-width: 767px) {
    display: flex;
    flex-direction: column-reverse;
    text-align: left;
    padding: 18px 24px;
    border-radius: 15px;
    background: linear-gradient(180deg, #BAC7D2 13.09%, rgba(2, 2, 2, 0) 100%);
    z-index: -1;
    margin-bottom: 20px;
    &:last-of-type {
      margin-bottom: 0;
    }
    &:before {
      content: '';
      position: absolute;
      display: block;
      border-radius: inherit;
      background: #fff;
      top: 2px;
      left: 2px;
      bottom: 2px;
      right: 2px;
      z-index: -1;
      background: linear-gradient(180deg, #1B1E25 0%, #040404 100%);
    }
    p, h5 {
      font-weight: 400 !important;
      font-size: 14px;
    }
    a {
      position: absolute;
      right: 24px;
      bottom: 18px;
      font-size: 14px;
      padding: 3.5px 20px;
    }
    i {
      left: -36px;
      transform: translateX(-50%) translateY(-50%);
      top: 50%;
      z-index: 200;
      width: 12px;
      height: 12px;
      border-radius: 999px;
      background-color: #C7C7CC;
    }
    &.${classes.active} {
      background: linear-gradient(90deg, #35EBFF 0%, #025BFF 100%);
    }
  }
`;
      function Timeline(props) {
        const {
          current,
          items
        } = props;
        const container = reactExports.useRef(null);
        const [progress, setProgress] = reactExports.useState(0);
        const isMobile = useMobile();
        reactExports.useEffect(() => {
          var _a;
          const el = (_a = container.current) == null ? void 0 : _a.querySelector(`.${classes.item}:nth-child(${current})`);
          if (el) {
            let onResize = function() {
              var _a2, _b;
              if (isMobile) {
                const offsetTop = el.offsetTop - (((_a2 = el.parentElement) == null ? void 0 : _a2.offsetTop) || 0);
                const height = el.offsetHeight;
                animate(0, offsetTop + height / 2, {
                  onUpdate(latest) {
                    setProgress(latest);
                  }
                });
              } else {
                const offsetLeft = el.offsetLeft - (((_b = el.parentElement) == null ? void 0 : _b.offsetLeft) || 0);
                const width = el.offsetWidth;
                animate(0, offsetLeft + width / 2, {
                  onUpdate(latest) {
                    setProgress(latest);
                  }
                });
              }
            };
            onResize();
            window.addEventListener("resize", onResize);
            return () => {
              window.removeEventListener("resize", onResize);
            };
          }
        }, [current, isMobile]);
        return /* @__PURE__ */ jsxRuntimeExports.jsxs(MainWrapper, { image: props.image, children: [
          props.heading && /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { dangerouslySetInnerHTML: {
            __html: props.heading
          } }),
          props.desc && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "section-desc", children: props.desc }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "timeline-content", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "progress", style: {
              "--progress": `${progress}px`
            }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "timeline-bar" }) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(Container, { ref: container, children: items.map((item, index) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Item, { className: clsx(classes.item, {
              [classes.active]: current >= index + 1,
              [classes.disabled]: item.disabled
            }), children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("i", {}),
              /* @__PURE__ */ jsxRuntimeExports.jsx("h5", { children: item.title }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("p", { dangerouslySetInnerHTML: {
                __html: item.content || ""
              } }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: item.link, children: item.disabled ? props.ended_text : current >= index + 1 ? props.join_now_text : props.stay_tuned_text })
            ] }, index)) })
          ] })
        ] });
      }
    }
  };
});
